import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { Stack } from '../../components/stack';

export type PageContentProps = PropsWithChildren;

/** @experimental In active development. Avoid using until further notice. */
export const PageContent = forwardRef<HTMLDivElement, PageContentProps>(
  ({ children }, ref) => {
    return (
      <Stack
        ref={ref}
        className="page-content"
        direction="column"
        spacing={3} // consistent spacing between page containers
        sx={{
          flex: 1,
          paddingTop: 3,
          paddingX: 5,
          paddingBottom: 5,
        }}
      >
        {children}
      </Stack>
    );
  },
);
